import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { useMutations } from "./hook/use-mutations";
// import { DashboardTable } from "./utils/dashboard-table";
import { ListPageTopBar } from "@/components/layout/dashboard-layout";
// import { RangeDateSelector } from "./utils/range-date-selector";
import { ChartCard } from "./utils/chart-card";
import {
  BookCopy,
  // CheckIcon,
  ChevronsLeftRightEllipsis,
  CircleCheckBig,
  ContactIcon,
  FileTextIcon,
  // FileX2Icon,
  Loader2,
  TrendingDownIcon,
  // TrendingUpDownIcon,
  // TrendingUpIcon,
  // XIcon,
} from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { RangeDateSelector } from "@/components/form-input/range-date-selector";
import { DashboardTable } from "./utils/dashboard-table";

export const DashboardPage = () => {
  const { genericState, redirect, company_id, dateRange, onDateRange } =
    useMutations();

  return (
    <div className="flex flex-col gap-5">
      <ListPageTopBar title={"Dashboard"}>
        <div className="">
          <RangeDateSelector onChange={onDateRange} date={dateRange} />
        </div>
      </ListPageTopBar>

      <ConditionRenderer condition={genericState.skelton}>
        <Card>
          <div className="flex items-center justify-center h-[300px]">
            <Loader2 className="animate-spin" size={30} />
          </div>
        </Card>
        <>
          <div
            className={cn(
              `grid  gap-5`,
              company_id == "system"
                ? "grid-cols-2 md:grid-cols-6"
                : "grid-cols-2 md:grid-cols-4",
            )}
          >
            {company_id == "system" ? (
              <ChartCard
                color="sky-blue"
                icon={ContactIcon}
                label="Company"
                value={genericState.company}
                onClick={() => {}}
              />
            ) : null}

            <ChartCard
              color="gray"
              icon={FileTextIcon}
              label="Total Processed Files"
              value={genericState.total_processed_files}
              onClick={() => {}}
            />

            <ChartCard
              color="blue"
              icon={CircleCheckBig}
              label="Snc Success"
              value={genericState.snc_success}
              onClick={() => redirect("snc_success", genericState.snc_success)}
              className={
                genericState.snc_success && company_id !== "system"
                  ? "cursor-pointer"
                  : ""
              }
            />
            <ChartCard
              color="green"
              icon={CircleCheckBig}
              label="Erp Success"
              value={genericState.erp_success}
              onClick={() => redirect("erp_success", genericState.erp_success)}
              className={
                genericState.failed && company_id !== "system"
                  ? "cursor-pointer"
                  : ""
              }
            />
            <ChartCard
              color="red"
              icon={TrendingDownIcon}
              label="Erp Failed"
              value={genericState.erp_failed}
              onClick={() => redirect("erp_failed", genericState.erp_failed)}
              className={
                genericState.erp_failed && company_id !== "system"
                  ? "cursor-pointer"
                  : ""
              }
            />
            <ChartCard
              color="orange"
              icon={ChevronsLeftRightEllipsis}
              label="On Hold"
              value={genericState.on_hold}
              onClick={() => redirect("on_hold", genericState.on_hold)}
              className={
                genericState.on_hold && company_id !== "system"
                  ? "cursor-pointer"
                  : ""
              }
            />
            <ChartCard
              color="red"
              icon={TrendingDownIcon}
              label="Validation Failed"
              value={genericState.validation_failed}
              onClick={() =>
                redirect("validation_failed", genericState.validation_failed)
              }
              className={
                genericState.erp_failed && company_id !== "system"
                  ? "cursor-pointer"
                  : ""
              }
            />
            <ChartCard
              color="red"
              icon={TrendingDownIcon}
              label="Failed"
              value={genericState.failed}
              onClick={() => redirect("failed", genericState.failed)}
              className={
                genericState.erp_failed && company_id !== "system"
                  ? "cursor-pointer"
                  : ""
              }
            />
            <ChartCard
              color="orange"
              icon={BookCopy}
              label="Duplicate"
              value={genericState.duplicate}
              onClick={() => redirect("duplicate", genericState.duplicate)}
              className={
                genericState.duplicate && company_id !== "system"
                  ? "cursor-pointer"
                  : ""
              }
            />
          </div>
          <DashboardTable
            data={genericState.data}
            isAdmin={company_id == "system"}
          />
        </>
      </ConditionRenderer>
    </div>
  );
};
